import { useLocation } from "react-router";
import { api } from "../../../api";
import { useMaybeFindFirst } from "@gadgetinc/react";
import { LoadScenario } from "../../../externalComponents/LoadScenario";
import LoadingSpinner from "../../../externalComponents/LoadingSpinner";
import { useContext } from "react";
import { CustomerContext } from "../../../providers";
import { FallbackPage } from "../../../externalComponents/FallbackPage";

export default function EditChatbotPage() {
  const location = useLocation();
  const scenarioId = location.pathname.split("/").slice(-1)[0];
  const { customer } = useContext(CustomerContext);

  const [result] = useMaybeFindFirst(api.scenario, {
    filter: {
      customerId: { equals: customer.id },
      id: { equals: scenarioId },
    },
    select: {
      id: true,
      type: true,
      name: true,
      chatbotType: true,
      triggerCount: true,
      rootNode: {
        id: true,
        whatsappTrigger: {
          id: true,
        },
      },
      status: true,
    },
  });
  const { data, fetching } = result;

  return fetching ? (
    <LoadingSpinner />
  ) : !data ? (
    <FallbackPage />
  ) : (
    <LoadScenario scenario={data} />
  );
}
